var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.2883H6V6.28833H10V8.28833C10.8526 7.20358 12.1456 6.5569 13.525 6.52533C16.0056 6.5391 18.0072 8.55771 18 11.0383V18.2883H14V11.5383C13.84 10.421 12.8818 9.59191 11.753 9.59433C11.2593 9.60994 10.7932 9.82611 10.4624 10.193C10.1316 10.5598 9.96464 11.0456 10 11.5383V18.2883ZM4 18.2883H0V6.28833H4V18.2883ZM2 4.28833C0.89543 4.28833 0 3.3929 0 2.28833C0 1.18376 0.89543 0.28833 2 0.28833C3.10457 0.28833 4 1.18376 4 2.28833C4 2.81876 3.78929 3.32747 3.41421 3.70254C3.03914 4.07762 2.53043 4.28833 2 4.28833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.24351b20c73db49c5550ebfd598381ff.svg";
export { ForwardRef as ReactComponent };